import React from "react"
import { Link, useLocation } from "react-router-dom"

const formatBreadcrumbName = (segment) => {
  const titleCase = segment
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase())

  if (titleCase.length > 32) {
    return `${titleCase.slice(0, 18)}...${titleCase.slice(-8)}`
  }

  return titleCase
}

// Simple breadcrumb navigation based on the current location
export default function Breadcrumbs() {
  const location = useLocation()
  const pathnames = location.pathname.split("/").filter((x) => x)

  return (
    <nav aria-label="Breadcrumb" className="px-4 py-2 max-w-full overflow-x-hidden">
      <ol className="flex flex-wrap text-sm text-gray-500 gap-x-2 gap-y-1 max-w-full">
        <li className="min-w-0 break-words">
          <Link to="/" className="hover:underline break-all">
            Home
          </Link>
        </li>
        {pathnames.map((value, index) => {
          const to = `/${pathnames.slice(0, index + 1).join("/")}`
          const isLast = index === pathnames.length - 1
          const name = formatBreadcrumbName(value)

          return (
            <li key={to} className="flex items-center gap-x-2 min-w-0 max-w-full">
              <span>/</span>
              {isLast ? (
                <span className="break-all" title={value}>{name}</span>
              ) : (
                <Link to={to} className="hover:underline break-all" title={value}>
                  {name}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    </nav>
  )
}
